import React from "react";
import Section from "../components/Section";
import Card from "../components/Card";

function InsightsPage() {
  return (
    <div>
      <Section
        eyebrow="Insights"
        title="How we think about markets, risk, and wealth."
        kicker="Plain-language commentary designed to keep you out of trouble, not whip you into a panic."
      >
        <p style={{ fontSize: 14, color: "#64748b" }}>
          Your dev can wire this up to a blog, CMS, or newsletter later. For
          now, this is just a placeholder.
        </p>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: "1.25rem",
          }}
        >
          <Card
            tag="Perspective"
            title="What really matters in a 30-year plan"
            body="Most headlines are irrelevant to your actual plan. We’ll help you focus on the 3–4 variables that truly drive your outcome."
          />
          {/* VANGUARD INSIGHT UPDATE */}
          <Card
            tag="Risk Management"
            title="The cost of a bad decision is higher than a market dip."
            body="We focus on helping you avoid impulsive decisions during emotional moments—the single largest source of underperformance for HNW investors."
          />
          <Card
            tag="Behavior"
            title="Why cash flow beats forecasting"
            body="Rather than predicting the future, we map inflows and outflows across time so that you always know your options."
          />
        </div>
      </Section>
    </div>
  );
}

export default InsightsPage;
